export const getAvailabilityColor = (availability) => {
  if (availability === 0) return "#ff4d4f"; // Red for 0 availability
  if (availability >= 1 && availability <= 3) return "#ffec3d"; // Yellow for 1-3 availability
  return "#73d13d"; // Green for availability > 3
};
